<div class="template-generator-dynamic">
  <div class="template-controls">
    <label for="static-template-select">Static Template: </label>
    <select
      id="static-template-select"
      #dynamicStaticSelect
      (change)="
        parentComponent.setDynamicStaticUUID(
          this.mode,
          dynamicStaticSelect.value
        )
      "
    >
      <option value="">None</option>
      @for (template of parentComponent.loadAllTemplatesFromSaved(true); track
      template) {
      <option
        [value]="template.uuid"
        [selected]="
          template.uuid ===
          parentComponent.selectedCustomTemplatesDynamicStaticUUID[this.mode]
        "
      >
        {{ template["name"] }}
      </option>
      }
    </select>
  </div>
  <div class="template-controls">
    <label for="dynamic-template-select">Dynamic Template: </label>
    <select
      id="dynamic-template-select"
      #dynamicDynamicSelect
      (change)="
        parentComponent.setDynamicDynamicUUID(
          this.mode,
          dynamicDynamicSelect.value
        )
      "
    >
      <option value="">None</option>
      @for (template of parentComponent.loadAllTemplatesFromSaved(false); track
      template) {
      <option
        [value]="template.uuid"
        [selected]="
          template.uuid ===
          parentComponent.selectedCustomTemplatesDynamicUUID[this.mode]
        "
      >
        {{ template["name"] }}
      </option>
      }
    </select>
    <button
      mat-flat-button
      (click)="
        parentComponent.saveTemplate(
          parentComponent.selectedCustomTemplatesDynamicUUID
        )
      "
      [disabled]="!parentComponent.selectedCustomTemplatesDynamicUUID"
    >
      Save
    </button>
    <button mat-flat-button (click)="parentComponent.saveTemplateAsNew(false)">
      Save As New
    </button>
  </div>
  @if (parentComponent.currentSlug?.isDevelopment) {
  <div class="development-banner">
    Denne side er under udvikling og er ikke endelig
  </div>
  }
  <div class="template-controls">
    <!-- Add a select and button to copy components from one mode to another -->
    <label for="copy-components-select">Copy Components From: </label>
    <select id="copy-components-select" [(ngModel)]="copyComponentsFromMode">
      @for (mode of [1, 2, 3]; track mode) {
      <option [value]="mode">
        {{ mode === 1 ? "Desktop" : mode === 2 ? "Tablet" : "Mobile" }}
      </option>
      }
    </select>
    <button
      mat-flat-button
      (click)="
        parentComponent.copyComponentsFromMode(
          copyComponentsFromMode,
          this.mode
        )
      "
    >
      Copy Components
    </button>
  </div>
  <div class="component-controls">
    <label for="component-select">Available Components: </label>
    <select
      id="component-select"
      [(ngModel)]="selectedCustomComponentDynamicName"
    >
      @for (comp of parentComponent.availableComponents | keyvalue; track comp)
      {
      <option [value]="comp.value.name">{{ comp.key }}</option>
      }
    </select>
    <button
      mat-flat-button
      (click)="
        parentComponent.addComponentToTemplate(
          selectedCustomComponentDynamicName,
          parentComponent.getSelectedTemplate(
            parentComponent.selectedCustomTemplatesDynamicUUID[this.mode] ||
              null
          ),
          this.mode
        )
      "
    >
      Add Component
    </button>
  </div>
  <div class="preview-wrapper screen-mode-{{ mode }}">
    <div #previewContainer class="preview-container">
      <div class="grid-container">
        @if (parentComponent.dataLoaded) { @for (staticComponent of
        parentComponent.getSelectedTemplateComponents(parentComponent.selectedCustomTemplatesDynamicStaticUUID[this.mode]
        || null, this.mode); track staticComponent) {
        <div
          class="grid-item"
          [ngClass]="{
            'static-component': staticComponent.name !== 'MainComponent'
          }"
          [id]="staticComponent.name + '_' + staticComponent.uuid + '_parent'"
          [ngStyle]="{
            'grid-column':
              (staticComponent.x || 0) +
              1 +
              ' / span ' +
              (staticComponent.cols || 1),
            'grid-row':
              (staticComponent.y || 0) +
              1 +
              ' / span ' +
              (staticComponent.name === 'MainComponent'
                ? 200
                : staticComponent.rows || 1)
          }"
        >
          @if (staticComponent.name === 'MainComponent') {
          <div class="dynamic-gridster-container">
            <div
              class="gridster-container"
              (dragenter)="onDragEnter($event)"
              (dragleave)="onDragLeave($event)"
              (dragover)="onDragOver($event)"
              (drop)="onDrop($event)"
            >
              <gridster [options]="gridOptions">
                @for (item of
                parentComponent.getSelectedTemplateComponents(parentComponent.selectedCustomTemplatesDynamicUUID[this.mode]
                || null, this.mode); track item) {
                <gridster-item [item]="item">
                  <div
                    class="grid-item"
                    [attr.data-uuid]="item.uuid"
                    [attr.data-container-uuid]="
                      item.name === 'ComponentContainerComponent'
                        ? item.uuid
                        : null
                    "
                  >
                    <div class="drag-handle">
                      <div class="button-container">
                        <button
                          id="edit_button"
                          (click)="
                            $event.stopPropagation();
                            parentComponent.editComponentFromGridster(
                              item.uuid!,
                              parentComponent
                                .selectedCustomTemplatesDynamicUUID[
                                this.mode
                              ] || null
                            )
                          "
                        >
                          E
                        </button>
                        <button
                          id="copy_button"
                          (click)="
                            $event.stopPropagation(); copyComponent(item)
                          "
                        >
                          C
                        </button>
                        <button
                          id="delete_button"
                          (click)="
                            $event.stopPropagation();
                            parentComponent.removeComponentFromGridster(
                              item,
                              parentComponent
                                .selectedCustomTemplatesDynamicUUID[
                                this.mode
                              ] || null
                            )
                          "
                        >
                          D
                        </button>
                      </div>
                    </div>
                    <div
                      class="content-area"
                      draggable="true"
                      (dragstart)="onDragStart($event, item)"
                      (dragend)="onDragEnd($event)"
                    >
                      <app-dynamic-component
                        [customComponent]="item"
                        [editorMode]="true"
                      >
                      </app-dynamic-component>
                    </div>
                  </div>
                </gridster-item>
                }
              </gridster>
            </div>
          </div>
          } @else {
          <app-dynamic-component
            [customComponent]="staticComponent"
          ></app-dynamic-component>
          }
        </div>
        } }
      </div>
    </div>
  </div>
</div>
